import { gql } from '@apollo/client/core';

/**
 * One selection for both the team list and the save payload, so the two cannot drift.
 *
 * `user.active` is what the Team screen's Active column and its resend-invite button read —
 * true once the member has signed in, false while their invitation is outstanding.
 */
export const USER_ACCOUNT_FIELDS = gql`
  fragment UserAccountFields on UserAccount {
    id
    role
    teamRole {
      id
      name
    }
    user {
      id
      name
      email
      active
    }
  }
`;
